import { Pagination } from '../common';

/**
 *
 * @export
 * @interface ListChangesetResponse
 */
export interface ListChangesetResponse {
  /**
   *
   * @type {Changesets}
   * @memberof ListChangesetResponse
   */
  results: Changesets;
  /**
   *
   * @type {PaginationDefinition}
   * @memberof ListChangesetResponse
   */
  pagination: Pagination;
}

/**
 *
 * @export
 * @interface Changesets
 */
export type Changesets = Array<Changeset>;

/**
 *
 * @export
 * @interface Changeset
 */
export interface Changeset {
  /**
   *
   * @type {Array<ChangesetDifference>}
   * @memberof Changeset
   */
  changes?: Array<ChangesetDifference>;
  /**
   * Autodesk ID of the user
   * @type {string}
   * @memberof Changeset
   */
  createdBy?: string;
  /**
   *
   * @type {string}
   * @memberof Changeset
   */
  createdAt?: string;
  /**
   *
   * @type {string}
   * @memberof Changeset
   */
  event?: ChangesetEvent;
}

/**
 *
 * @export
 * @interface ChangesetDifference
 */
export interface ChangesetDifference {
  /**
   *
   * @type {string}
   * @memberof ChangesetDifference
   */
  propertyName: string;
}

/**
 * @export
 * @enum {string}
 */
export enum ChangesetEvent {
  Update = <any>'update',
  Create = <any>'create',
  Delete = <any>'delete',
}
